import React from 'react'

const Type = ({row}) => {
  const getLabelType = (typeId) => {
    switch (typeId) {
      case 0:
        return "All";
      case 1:
        return "Debit";
      case 2:
        return "Credit";
      default:
        return "All";
    }
  }
  return (
    <div>{getLabelType(row?.typeId)}</div>
  )
}

export default Type